// Web Component: ContactZendesk
// Gestisce il form di contatto Zendesk, mostra/nasconde ordini e invia dati tramite eventi custom.
// Attributi richiesti: data-showOrders, presenza di theme-form e template figli
// Dipendenze: Utils, theme-form
// Limiti: richiede struttura HTML compatibile e dati corretti
// Utilizzato per la gestione delle richieste di supporto tramite Zendesk
class ContactZendesk extends HTMLElement {
  form; button; options;

  connectedCallback() {
    this.templates = this.querySelectorAll('[data-template]');
    this.options = this.dataset.showOrders.split(',');
    this.form = this.querySelector('theme-form');

    this.initForm();
    this.form.addEventListener(Utils.E_FORM_SUBMIT, this.submitForm.bind(this));
    this.form.addEventListener(Utils.E_FORM_SUCCESS, (e) => {this.success(e.detail)});
  }

  initForm = () => {
    const select = this.querySelector('#request-type');
    if(select){
      select.addEventListener('change', () => {
        this.options.filter((option) => option == select.value).length > 0 ? this.showOrders() : this.hideOrders();
      });
    }
  }

  showOrders = () => {
    const orders = this.querySelector('#request-order');
    if(orders){
      orders.closest('.form-group').classList.remove('d-none');
    }
  }

  hideOrders = () => {
    const orders = this.querySelector('#request-order');
    if(orders){
      orders.closest('.form-group').classList.add('d-none');
    }
  }

  submitForm = (e) => { 
    let customFields = this.form.data.request.custom_fields;
    let newCustomFields = [];

    Object.keys(customFields).forEach(key => {
        let field = customFields[key];
        field.id = parseInt(field.id);
        newCustomFields.push(field);
    });
    this.form.data.request.custom_fields = newCustomFields;
  }

  success = (data) => {
    const template = this.getTemplate('success');
    this.innerHTML = template.replaceAll('{ticket}', data.request.id);
    Shopify.analytics.publish(Utils.E_CONTACT, data);
    window.dispatchEvent(new CustomEvent(Utils.E_CONTACT, { detail: data }));
  }

  getTemplate = (name) => { 
    const t = Array.from(this.templates).filter((template) => template.dataset.template === name);
    return t.length > 0 ? t[0].innerHTML : null;
  }
}
if (!customElements.get('contact-zendesk')) {
  customElements.define('contact-zendesk', ContactZendesk);
}